import React, {useState, useEffect, useRef} from "react";
import {useNavigate, Link, useLocation, useParams} from "react-router-dom";
import {connect, useSelector, useDispatch} from "react-redux";
import get from "lodash/get";
import map from "lodash/map";
import sumBy from "lodash/sumBy";
import filter from "lodash/filter";
import classNames from "classnames";
import PaymentSuccessPopup from "./paymentSuccessPopup";
import {withButtonLoader} from "../../helpers";
import CustomPopover from "../../Components/CustomPopover";
import CustomPopoverPayment from "../../Components/CustomPopoverPayment";

import {
    getPaymentsToken,
    getUserData,
    savePaymentsData,
    getAdminUserData,
    logoutAct,
    transactionError,
    updateUserData,
    deleteCard,
    onTransactionLoading,
    reduxSetPayerUser,
    getPayerUserById,
} from "../../Actions/authActions";
import {SAVE_TRANSACTION_LOADING, SAVE_TRANSACTION_ERROR, SAVE_TRANSACTION_SUCCESS} from "../../constants";
import {
    formatCreditCardNumber, formatExpirationDate, formatCVC,
} from "./utils";
import {
    eventUrl, subDomain, amountFormatter, amountFormatterWithZero, saveLogRocketSession, captureError, trackSessionError, detectInAppBrowser, getInAppBrowserInstructions, copyCurrentUrl, addBreadcrumb,
} from "../../utils";
import CustomRadio from "../../Components/CustomRadio";
import CustomCheckbox from "../../Components/CustomCheckBox";
import EditCardInfo from "../EditCardInfo";
import "./payments.css";
import {Helmet} from "react-helmet";
import {
    CreditCardIcon, ECheckIcon, HhaCardIcon, RefreshIcon, DownArrowIcon, MousePointerIcon, AddCardIcon,
    ApplePayIcon, GooglePayIcon,
} from "../../Components/Icons";
import {PaymentFactory} from "../../Payments/paymentFactory";
import CardExpiration from "../../Components/Forms/CardExpiration";
import {showPaymentError} from "../../Payments/errorHandler";
import CreditCardManualNmiFields from "../AdminDashboard/CreditCardManualNmiFields";
import ApplePayNmi from "../../Components/Payment/ApplePayNmi";
import GooglePayNmi from "../../Components/Payment/GooglePayNmi";


const Payments = (props) => {
    const {match} = props || {};


    const params = useParams();
    const subdomain = params.subdomain || subDomain();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const user = useSelector((state) => state.auth.user);
    const adminUser = useSelector((state) => state.auth.adminUser);
    const paymentGatewayType = useSelector((state) => state.auth.adminUser?.paymentGateways?.type);
    const logoUrl = useSelector((state) => state.auth.adminUser?.logoUrl);
    const themeColor1 = get(adminUser, "theme.themeColor1");
    const themeColor2 = get(adminUser, "theme.themeColor2");
    let globalCustomCSSWithTheme;
    globalCustomCSSWithTheme = `.sos-mack-btn:hover .css-15llytj span {background: ${themeColor1}} .sos-custom-btn:hover .css-15llytj span {background: ${themeColor1}} .sos-custom-btn-css {background:${themeColor1};  border: 1px solid  ${themeColor1} } .sos-custom-btn-css:hover {color: ${themeColor1}; border: 1px solid ${themeColor1}} .nav-list-item a:hover {border-bottom: 3px solid ${themeColor1 ? themeColor1 : "#6e86c4"}} .nav-list-selected {border-bottom: 3px solid ${themeColor1 ? themeColor1 : "#6e86c4"}} .message-received-text:hover {color: ${themeColor1}} .nav-item:hover {box-shadow: 0 0 0 3px ${themeColor1 ? themeColor1 : "#6e86c4"} !important;} .nav-item.active {box-shadow: 0 0 0 3px ${themeColor1 ? themeColor1 : "#6e86c4"} !important;} .custom-radio .custom-radio-checked:after {background: ${themeColor1 ? themeColor1 : "#6e86c4"}} .custom-checkbox {border: 1px solid ${themeColor1 ? themeColor1 : "#6e86c4"}} .custom-checkbox .custom-checkbox-checked:after {border: solid ${themeColor1 ? themeColor1 : "#6e86c4"}; border-width: 0 3px 3px 0;} .text-cerulean {color:${themeColor1}} .payment-raound {color:${themeColor1}} .sos-content .custom-input-border-css {border: 1px solid ${themeColor2 ? themeColor2 : "#94bbad"}} .sos-content .form-control:focus {box-shadow: 0 0 0 0.15rem ${themeColor2};border: ${themeColor2} } `;
    const transactionLoading = useSelector((state) => state.auth.transactionLoading);

    const [showPopUpAutomatic, setShowPopUpAutomatic] = useState(false);
    const [title, setTitle] = useState("");
    const {patientPayer} = user || {};
    const [patientPayerInfo, setPatientPayerInfo] = useState([]);
    const [showDefaultChecked, setShowDefaultChecked] = useState();
    const [selectedCardId, setSelectedCardId] = useState("");
    // const [popoverTitle, setPopoverTitle] = useState("");
    const [cardId, setCardId] = useState("");
    const [editCardInfo, setEditCardInfo] = useState(false);
    const [isPaymentSaveDetails, setIsPaymentSaveDetails] = useState(true);
    const [showPopUp, setShowPopUp] = useState(false);
    const [target, setTarget] = useState(null);
    const [paymentType, setPaymentType] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [paymentMsg, setPaymentMsg] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [selectedPayment, setSelectedPayment] = useState("");
    const [selectedAmount, setSelectedAmount] = useState("");
    const [isDefault, setIsDefault] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState({
        name: "", amount: "", cardnumber: "", expiry: "", cvv: "",
    });
    const [accountType, setAccountType] = useState("");
    const [manual, setManual] = useState(null);
    const [paymentLoadError, setPaymentLoadError] = useState(null);
    const [errorType, setErrorType] = useState(null);
    const [errorKey, setErrorKey] = useState(null);
    const [originalTransaction, setOriginalTransaction] = useState(null);
    const [inAppBrowserWarning, setInAppBrowserWarning] = useState(null);
    const [inAppBlocked, setInAppBlocked] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const latestRef = useRef({
        subdomain,
        adminUser,
        user,
        manual,
        isPaymentSaveDetails,
        isDefault,
        paymentType,
        selectedPayment,
        paymentInfo,
        patientPayerInfo,
    });

    // keep ref up to date
    useEffect(() => {
        latestRef.current = {
            subdomain,
            adminUser,
            user,
            manual,
            isPaymentSaveDetails,
            isDefault,
            paymentType,
            selectedPayment,
            paymentInfo,
            patientPayerInfo,
        };
    }, [
        subdomain,
        adminUser,
        user,
        manual,
        isPaymentSaveDetails,
        isDefault,
        paymentType,
        selectedPayment,
        paymentInfo,
        patientPayerInfo,
    ]);

    const goBack = () => {
        navigate(`${eventUrl(subdomain)}home`);
    };

    const getNewPatientPayer = () => {
        const balancesPaid = [];
        map(patientPayerInfo, (i) => {
            if (i) {
                balancesPaid.push({
                    patientFirst: i.patientFirst,
                    patientLast: i.patientLast,
                    patientNumber: i.patientNumber,
                    patientPayerId: i.patientPayerId,
                    amountPaid: i.accountBalance < 0 ? 0 : i.accountBalance,
                });
            }
        });
        return balancesPaid;
    };

    useEffect(() => {
        dispatch(getAdminUserData(subdomain));
    }, []);

    useEffect(() => {
        const check = detectInAppBrowser();
        if (check.inApp) setInAppBrowserWarning(check);
    }, []);

    useEffect(() => {
        if (adminUser && adminUser.paymentGateways && !manual) {
            initManualPayment();
        }
    }, [adminUser]);

    useEffect(() => {
        if (!(user && user._id)) {
            dispatch(getUserData(subdomain));
        }
    }, [!user]);

    useEffect(() => {
        if (user && user.paymentMethods && user.paymentMethods.length > 0) {
            const {paymentMethods} = user || "";
            const filterData = filter(paymentMethods, (p) => p.isDefault)[0];
            if (filterData && filterData._id) {
                setSelectedCardId(filterData._id);
                setSelectedPayment(filterData);
            } else {
                setSelectedCardId(paymentMethods[0]._id);
                setSelectedPayment(paymentMethods[0]);
            }
        }
    }, [user]);

    useEffect(() => {
        setIsPaymentSaveDetails(true);
        if ((paymentType === "creditCard" || paymentType === "hhaCard") && paymentGatewayType === 'NMI') {
            // Re-initialize manual payment to inject NMI iframes
            initManualPayment();
        }
    }, [paymentType]);


    useEffect(() => {
        if (user) {
            setShowDefaultChecked(user.paymentMethods);
        }
    }, [user]);

    useEffect(() => {
        const localState = localStorage.getItem('state');
        if (localState) {
            try {
                const parsedState = JSON.parse(localState);
                if (parsedState.patientPayerInfo) {
                    setPatientPayerInfo(parsedState.patientPayerInfo);
                }
            } catch (e) {
                // Corrupted localStorage state — fall through to patientPayer
            }
        }
        if (!localState && patientPayer && patientPayer.length > 0) {
            setPatientPayerInfo(patientPayer);
        }
    }, [patientPayer]);

    const onLogout = () => {
        dispatch(logoutAct(false, subdomain));
    };

    const totalAmountsPaid = () => {
        const total = sumBy(map(patientPayerInfo, (i) => ({
            ...i, accountBalance: i ? Math.max(parseFloat(i.accountBalance), 0) : 0,
        })), "accountBalance");
        return total;
    };

    useEffect(() => {
        if (patientPayerInfo && patientPayerInfo.length > 0) {
            setSelectedAmount(totalAmountsPaid());
        }
    }, [patientPayerInfo]);

    const totalAmounts = () => {
        const total = sumBy(map(patientPayerInfo, (i) => ({
            ...i, accountBalance: i ? Math.max(parseFloat(i.accountBalance), 0) : 0,
        })), "accountBalance");
        return total;
    };

    const onMakePayment = () => {
        navigate(`${eventUrl(subdomain)}payments`, {});
    };
    const postManualPayment = (response) => {
        try {
            if (!response.response) {
                response.response = {...response};
            }
            if (paymentType === "eCheck") {
                const transactionId = response?.ssl_txn_id || "";
                const ssl_bank_account_number = response.response?.ssl_bank_account_number?.substr(-4) || "";

                const ssl_card_short_description = response?.ssl_card_short_description || "";
                const ssl_card_type = response?.response.ssl_card_type || "";

                const paymentsDataToSave = {
                    paymentType,
                    ssl_card_short_description,
                    ssl_card_type,
                    ssl_bank_account_number,
                    userId: user && user._id,
                    transactionsData: {...response.response, bankName: response.bankName},
                    transactionId,
                    sosCustomersId: adminUser._id,
                    patientPayer: getNewPatientPayer(),
                    isDefault,
                    isPaymentSaveDetails,
                    isAdmin: false,
                    addedBy: {userId: user._id},
                    initiatedBy: {userId: user._id},
                    subdomain,
                };
                props.savePaymentsData(paymentsDataToSave).then((res) => {
                    if (res) {
                        showResult("approval");
                    }
                });
            } else {
                const ssl_card_number = response?.ssl_card_number?.substr(-4) || "";
                const transactionId = response?.ssl_txn_id || "";
                const ssl_token = response?.ssl_token || "";

                const ssl_card_short_description = response?.ssl_card_short_description || "";
                const ssl_card_type = response?.response.ssl_card_type || "";


                const paymentsDataToSave = {
                    paymentType,
                    ssl_card_short_description,
                    ssl_card_type,
                    userId: user._id,
                    transactionsData: response,
                    transactionId,
                    ssl_card_number, // dateTimeStampUTC: new Date().toISOString(),
                    ssl_token,
                    sosCustomersId: adminUser._id,
                    patientPayer: getNewPatientPayer(),
                    isDefault,
                    isPaymentSaveDetails,
                    isAdmin: false,
                    addedBy: {userId: user._id},
                    initiatedBy: {userId: user._id},
                    subdomain,
                };

                props.savePaymentsData(paymentsDataToSave).then((res) => {
                    if (res) {
                        localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                            payerEmail: res.user.payerEmail,
                            patientPayer: res.user.patientPayer,
                            createdAt: response.ssl_txn_time,
                            transactionsData: response,
                            total: response.ssl_amount,
                            transactionId: transactionId,
                        }));
                        showResult("approval");
                    }
                });
            }

            setPaymentInfo({
                name: "", cardnumber: "", expiry: "", cvv: "",
            });
        } catch (err) {
            console.log("Err #3iu53urg", err.message);
            showResult("error", err);
        }
        if (user) {
            dispatch(getUserData(subdomain));
        }
    }

    const initManualPayment = async () => {
        if (adminUser && adminUser.paymentGateways) {
            const factory = new PaymentFactory();
            try {
                const newManual = await factory.create('MANUAL', {
                    subdomain, adminUser, user
                }, handleSubmit);
                setManual(newManual);
                setPaymentLoadError(null);
            } catch (err) {
                console.error('Failed to initialize payment form:', err);
                const inAppCheck = detectInAppBrowser();
                if (inAppCheck.inApp || err?.errorType === 'IN_APP_BROWSER') {
                    setInAppBlocked(true);
                    setPaymentLoadError(`You opened this page from ${inAppCheck.app || 'an in-app browser'}. In-app browsers block payment processing. Please open this page in your default browser.`);
                } else {
                    setPaymentLoadError('Unable to load the payment form. Please check your internet connection and refresh the page to try again.');
                }
            }
        }
    }

    function showResult(status, err) {
        if (status === "approval") {
            setErrorKey(null);
            setOriginalTransaction(null);
            if (selectedAmount !== "") {
                setPaymentMsg("successful");
                setPaymentStatus("approval");
            } else {
                setPaymentMsg("addSuccessful");
                setPaymentStatus("approval");
            }
            saveLogRocketSession({
                eventType: "transaction",
                outcome: "success",
                eventUrl: subDomain(),
                userId: user?._id,
                sosCustomersId: adminUser?._id || null,
                gateway: adminUser?.paymentGateways?.type?.toLowerCase() || null,
                payMethod: paymentType || null,
                amount: totalAmountsPaid() || null,
            });
        } else if (status === "txnApprovedButPmtMethodNotStored") {
            setErrorKey(null);
            setPaymentMsg("The payment was successful. Unable to store payment method at this time.");
            setPaymentStatus("approval");
            saveLogRocketSession({
                eventType: "transaction",
                outcome: "success",
                eventUrl: subDomain(),
                userId: user?._id,
                sosCustomersId: adminUser?._id || null,
                gateway: adminUser?.paymentGateways?.type?.toLowerCase() || null,
                payMethod: paymentType || null,
                amount: totalAmountsPaid() || null,
            });
        } else if (status === "failure" || status === "error") {
            const errorMessage = showPaymentError(err);
            setPaymentMsg(`${errorMessage}`);
            setPaymentStatus("error");
            const errData = err?.response?.data || err;
            const key = errData?.errorKey || err?.errorKey;
            setErrorKey(key || null);
            setOriginalTransaction(errData?.originalTransaction || null);
            setErrorType(err?.errorType || (key === 'errorTimeout' || key === 'errorDuplicateTransaction' ? 'not_processed' : null));
            if (err?.errorType !== 'validation') {
                captureError(err instanceof Error ? err : new Error(String(errorMessage)), {
                    errorType: "payment_error",
                    context: {
                        gateway: adminUser?.paymentGateways?.type,
                        payMethod: paymentType,
                        zipSent: manual?.data?.zip || '(empty)',
                        billingZipInPaymentInfo: paymentInfo?.billingZip || '(empty)',
                        payerZip: user?.zip || '(empty)',
                        payerId: user?._id,
                        errorMessage,
                    },
                });
            }
            saveLogRocketSession({
                eventType: "error",
                outcome: "failure",
                eventUrl: subDomain(),
                userId: user?._id,
                sosCustomersId: adminUser?._id || null,
                gateway: adminUser?.paymentGateways?.type?.toLowerCase() || null,
                payMethod: paymentType || null,
                amount: totalAmountsPaid() || null,
                metadata: { error: errorMessage },
            });
        }
        setOpenModal(true);
    }

    const handleInputChange = ({target}) => {
        if (target.name === "cardnumber") {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === "expiry") {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === "cvc") {
            target.value = formatCVC(target.value);
        } else if (target.name === "accountType") {
            setAccountType(target.value);
        }
        setPaymentInfo({...paymentInfo, [target.name]: target.value});
    };

    const payWithSelected = async (e) => {
        dispatch(onTransactionLoading());
        const factory = new PaymentFactory();
        const patientPayer_info = [];
        map(patientPayerInfo, (i) => {
            patientPayer_info.push({
                patientFirst: i.patientFirst, patientLast: i.patientLast,
                patientNumber: i.patientNumber, patientPayerId: i.patientPayerId, amountPaid: i.accountBalance,
            });
        });
        const selected = await factory.create('SELECTED', {
            amount: amountFormatterWithZero(totalAmountsPaid()),
            subdomain,
            adminUser,
            payerUser: user,
            email: get(user, "payerEmail"),
            // isPaymentSaveDetails: formdata.isPaymentSaveDetails,
            // isDefault: formData.isDefault,
            patientPayer: patientPayer_info,
            paymentMethodId: selectedPayment._id,
            isEcheck: selectedPayment.paymentType === "eCheck"
        });

        selected.pay(e).then((res) => {
            if (paymentGatewayType === 'NMI') {
                if (res instanceof Error) {
                    showResult("error", "Transaction successful, but error while saving transaction; please report this error to software support.");
                    console.error("Err #sldkfjlsdkfj");
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                    return res;
                }
                if (res?.response === '1') {
                    localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                        payerEmail: user.payerEmail,
                        patientPayer: getNewPatientPayer(),
                        total: amountFormatterWithZero(totalAmountsPaid()),
                        transactionId: res?.transactionid,
                    }));
                    const updatedPatientPayers = patientPayer.map(ptPayer => {
                        const matchingPatientPayer = patientPayerInfo.find(ppInfo => ppInfo && ppInfo.patientPayerId === ptPayer.patientPayerId);
                        if (matchingPatientPayer) {
                            const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                            return {
                                ...ptPayer, accountBalance: unpaidBalance,
                            };
                        }
                        return ptPayer;
                    });
                    const updatedUser = {
                        ...user, patientPayer: updatedPatientPayers,
                    };
                    localStorage.setItem("state", JSON.stringify({patientPayerInfo: updatedPatientPayers}));
                    dispatch(reduxSetPayerUser(updatedUser));
                    showResult("approval");
                    dispatch({type: SAVE_TRANSACTION_SUCCESS});
                    setTimeout(() => {
                        dispatch(getUserData(subdomain));
                        setPaymentInfo({
                            name: "", cardnumber: "", expiry: "", cvv: "",
                        });
                    }, 1000);
                } else {
                    showResult("error", res);
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                }
            } else {
                // Converge handling
                if (!(selected.data.isEcheck)) {
                    postManualPayment(res);
                } else {
                    if (res.data.message === 'Transaction successful') {
                        showResult("approval");
                        setTimeout(() => {
                            dispatch(getUserData(subdomain));
                            dispatch({type: "PAYUSER_SUCCESS"});
                            setOpenModal(false);
                            setPaymentInfo({
                                name: "", cardnumber: "", expiry: "", cvv: "",
                            });
                        }, 1000);
                    } else {
                        showResult("failure", res);
                    }
                }
            }
        }).catch((err) => {
            showResult("error", err);
            dispatch({type: SAVE_TRANSACTION_ERROR});
        });
    };

    const handleSubmit = async (e) => {
        // pull latest info from the ref:
        const {
            subdomain,
            adminUser,
            user,
            manual,
            isPaymentSaveDetails,
            isDefault,
            paymentType,
            selectedPayment,
            paymentInfo,
            patientPayerInfo,
        } = latestRef.current;

        dispatch({type: SAVE_TRANSACTION_LOADING});
        let formData;
        if (e?.target?.elements) {
            formData = [...e.target.elements]
                .filter((d) => d.name)
                .reduce((acc, d) => {
                    if (["isPaymentSaveDetails", "isDefault"].includes(d.name)) {
                        acc[d.name] = d.value === "on";
                    } else {
                        acc[d.name] = d.value;
                    }
                    return acc;
                }, {});

        } else {
            formData = paymentInfo;
        }
        addBreadcrumb({
            category: 'payment.zip',
            message: 'handleSubmit formData source',
            level: 'info',
            data: {
                fromDom: !!e?.target?.elements,
                billingZip: formData.billingZip || '(empty)',
                formDataKeys: Object.keys(formData).join(','),
                paymentType,
            },
        });
        const payerEmail = get(user, "payerEmail") || "";
        let data = {
            amount: amountFormatterWithZero(totalAmountsPaid()),
            payerUser: user,
            adminUser,
            payerEmail,
            subdomain,
            isPaymentSaveDetails,
            isDefault,
            patientPayer: getNewPatientPayer()
        };
        if (paymentType === "eCheck") {
            const isPersonalAccount = accountType === "0";
            const isBusinessAccount = accountType === "1";
            data = {
                ...data,
                isEcheck: true,
                firstName: isPersonalAccount ? formData.accountFirstName : "",
                lastName: isPersonalAccount ? formData.accountLastName : "",
                companyName: isBusinessAccount ? formData.companyName : "",
                bankAccountType: accountType,
                bankName: formData.bankName,
                bankRoutingNumber: formData.bankRoutingNumber,
                bankAccountNumber: formData.bankAccountNumber
            }
        } else {
            data = {
                ...data,
                isEcheck: false,
                firstName: formData.cardFirstName || "",
                lastName: formData.cardLastName || "",
                expirationDate: formData && formData.expiry ? formData.expiry.replace(/\//g, "") : "",
                cardNumber: formData && formData.cardnumber,
                cvv: formData && formData.cvc ? formData.cvc : "",
                zip: formData.billingZip || "",
            };
        }
        addBreadcrumb({
            category: 'payment.zip',
            message: 'data built for manual.pay',
            level: 'info',
            data: {
                zip: data.zip || '(empty)',
                firstName: data.firstName || '(empty)',
                lastName: data.lastName || '(empty)',
                isEcheck: data.isEcheck,
                payerUserId: user?._id,
                subdomain,
            },
        });
        manual.data = data;
        manual.pay(e).then((res) => {
            if (paymentGatewayType === 'NMI') {
                if (res instanceof Error) {
                    showResult("error", "Transaction successful, but error while saving transaction; please report this error to software support.");
                    console.error("Err #sldkfjlsdkfj");
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                    return res;
                }
                if (res?.response === '1') {
                    localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                        payerEmail: user.payerEmail,
                        patientPayer: getNewPatientPayer(),
                        total: data.amount,
                        transactionId: res?.transactionid,
                    }));
                    const updatedPatientPayers = patientPayer.map(ptPayer => {
                        const matchingPatientPayer = patientPayerInfo.find(ppInfo => ppInfo && ppInfo.patientPayerId === ptPayer.patientPayerId);
                        if (matchingPatientPayer) {
                            const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                            return {
                                ...ptPayer, accountBalance: unpaidBalance,
                            };
                        }
                        return ptPayer;
                    });
                    const updatedUser = {
                        ...user, patientPayer: updatedPatientPayers,
                    };
                    localStorage.setItem("state", JSON.stringify({patientPayerInfo: updatedPatientPayers}));
                    dispatch(reduxSetPayerUser(updatedUser));
                    showResult("approval");
                    dispatch({type: SAVE_TRANSACTION_SUCCESS});
                    setTimeout(() => {
                        dispatch(getUserData(subdomain));
                        setPaymentInfo({
                            name: "", cardnumber: "", expiry: "", cvv: "",
                        });
                    }, 1000);
                } else {
                    showResult("error", res);
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                }
            } else {
                // Converge handling
                if (!(data.isEcheck && data.isPaymentSaveDetails && +res.ssl_amount > 0.01)) {
                    postManualPayment(res);
                } else {
                    if (res.data.message === "Transaction successful") {
                        showResult("approval");
                        setTimeout(() => {
                            dispatch(getUserData(subdomain));
                            dispatch({type: "PAYUSER_SUCCESS"});
                            setPaymentInfo({
                                name: "", cardnumber: "", expiry: "", cvv: "",
                            });
                        }, 1000);
                    } else {
                        showResult("failure", res);
                    }
                    dispatch(transactionError());
                }
            }
        }).catch((err) => {
            console.log("Err #bbfhdb3h", err)
            showResult("error", err);
            dispatch({type: SAVE_TRANSACTION_ERROR});
        });
    };

    const onCloseModal = () => {
        if (paymentStatus === "approval") {
            setOpenModal(false);
            setErrorType(null);
            setErrorKey(null);
            setOriginalTransaction(null);
            navigate(`${eventUrl(subdomain)}home`);
        } else {
            setOpenModal(false);
            setErrorType(null);
            setErrorKey(null);
            setOriginalTransaction(null);
        }
    };

    const handlePopUp = (event, i) => {
        setShowPopUp(!showPopUp);
        setTarget(event.target);
        // setPopoverTitle("Are you sure you want to remove this payment method?");
        setCardId(i._id);
    };

    const handleClosePopUp = () => {
        setShowPopUp(false);
        setCardId("");
    };

    const handleEditInfo = () => {
        setEditCardInfo(!editCardInfo);
        setSelectedPayment(selectedPayment);
        const noBalancePatientPayerInfo = patientPayerInfo.map(o => {
            return {
                ...o, accountBalance: "0"
            }
        });
        localStorage.setItem('state', JSON.stringify({noBalancePatientPayerInfo}));
        setSelectedAmount('');
    };

    const onDefaultChecked = (e, c, i) => {
        let userChecked = [...user.paymentMethods];
        let updateDefaultCard = [];
        const updatedUser = user;
        const selectedPayerId = e.target.checked ? userChecked[i]._id : "";


        map(userChecked, (p) => {
            const defaultCard = p;
            if (p._id === c._id) {
                defaultCard.isDefault = e.target.checked;
            } else {
                defaultCard.isDefault = false;
            }
            updateDefaultCard.push(defaultCard);
        });
        setShowDefaultChecked(updateDefaultCard);
        updatedUser.paymentMethods = updateDefaultCard;
        dispatch(updateUserData(updatedUser));
    };


    const onRemoveDoc = () => {
        setShowPopUp(!showPopUp);
        if (cardId) {
            const data = {
                cardId, userId: user._id,
            };
            props.deleteCard(subdomain, data).then((res) => {
                if (res.payload) {
                    dispatch(getUserData(subdomain));
                }
            });
        }
    };

    return (<>
        <div className="wrapper">
            <Helmet style={[{cssText: `${globalCustomCSSWithTheme}`}]}/>
            <div className="sos-card-login home-patient-box">
                <div className="w-100 d-flex justify-content-between">
                    <div className="w-100 d-flex align-items-center justify-content-between">
                    {/*<div >*/}
                        <div className="logo">
                            <img
                                src={logoUrl || "/images/logo.png"}
                                className="img-fluid"
                                alt="Logo"
                            />
                        </div>
                        <div>
                            <div style={{marginLeft:"20px"}}>
                                <span>{adminUser && adminUser.officeName && adminUser.officeName.toUpperCase() || ''}</span>
                            </div>
                            <div style={{marginLeft:"20px"}}>
                                <span>{adminUser && adminUser.publicEmail || ''}</span>
                            </div>
                            <div style={{marginLeft:"20px"}}>
                                <span>{adminUser && adminUser.publicPhone || ''}</span>
                            </div>
                        </div>
                    </div>
                    <div className="header">
                        <div className="d-flex align-items-center">
                            <span>{get(user, "payerEmail")}</span>
                            <Link
                                to="#"
                                className="text-cerulean message-received-text"
                                onClick={() => onLogout()}
                            >
                                Logout
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="d-md-flex sos-mack">
                    <div className="navbar-content">
                        <nav className="bg-light">
                            <ul className="navbar-nav ">
                                <li className="nav-item home-link">
                                    <Link
                                        className="nav-link"
                                        to={`${eventUrl(subdomain)}home`}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    {/*<div onClick={()=>onMakePayment()} className="nav-link active">*/}
                                    {/*    Make a Payment*/}
                                    {/*</div>*/}
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="payment-patient">
                        <div className="payment-patient-inner position-relative">
                            {!editCardInfo ? (<div>
                                <div
                                    className="hommeexisting-large-text hommeexisting-hoiz-text d-flex  justify-content-between">
                                    <p>{selectedAmount > "" ? `Amount Being Paid` : ''} </p>
                                    <p>{selectedAmount > "" ? 'Account Balance' : ''}</p>
                                </div>
                                <div
                                    className="cross-btn"
                                    onClick={() => goBack()}
                                >
                                    <svg width="15px" height="17px" viewBox="0 0 18 18">
                                        <path
                                            d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                                    </svg>
                                </div>
                                <div className="payment-inner-text container">
                                    <div className="payment-amount d-flex  justify-content-between">
                                        <p className="ml-5">
                                            {selectedAmount > "" ? `$${amountFormatterWithZero(selectedAmount)}` : ''}
                                        </p>
                                        <span className="ml-5 account-balance">
                          {selectedAmount > "" ? `${amountFormatterWithZero(totalAmounts())}` : ''}
                        </span>
                                    </div>
                                    {paymentType === "creditCard" || paymentType === "eCheck" || paymentType === "hhaCard" || paymentType === "applePay" || paymentType === "googlePay" ? (
                                        <div>
                                            <div className="payment-patient-style">
                                                {selectedAmount === "" ? 'Add payment method' : 'Select your payment method'}
                                            </div>
                                            <div className="container payment-toggleable">
                                                {inAppBlocked ? (
                                                    <div className="in-app-browser-block">
                                                        <div className="in-app-browser-block-icon">&#128274;</div>
                                                        <h4>Payment Unavailable</h4>
                                                        <p>In-app browsers block payment processing. Please open this page in {/iPhone|iPad/i.test(navigator.userAgent) ? 'Safari' : 'Chrome'} to continue.</p>
                                                        <p className="in-app-browser-block-instructions">{inAppBrowserWarning ? getInAppBrowserInstructions(inAppBrowserWarning.app) : ''}</p>
                                                        <button className={`in-app-browser-copy-btn${linkCopied ? ' in-app-browser-copy-btn--copied' : ''}`} onClick={async () => {
                                                            const ok = await copyCurrentUrl();
                                                            if (ok) {
                                                                setLinkCopied(true);
                                                                setTimeout(() => setLinkCopied(false), 3000);
                                                            }
                                                        }}>{linkCopied ? 'Link Copied! Paste in Safari' : 'Copy Link to Open in Browser'}</button>
                                                        {/Android/i.test(navigator.userAgent) && (
                                                            <button className="in-app-browser-open-btn" style={{marginTop: '8px'}} onClick={() => {
                                                                const url = window.location.href;
                                                                window.location.href = 'intent://' + url.replace(/^https?:\/\//, '') + '#Intent;scheme=https;end';
                                                            }}>Open in Chrome</button>
                                                        )}
                                                    </div>
                                                ) : (<>
                                                <ul
                                                    className="justify-content-lg-center justify-content-center mb-3 nav nav-pills"
                                                    id="pills-tab"
                                                    role="tablist"
                                                >
                                                    {adminUser.displayECheck && (<li
                                                        className={classNames("nav-item chekbox-custom mr-2 me-2 rectangle", paymentType === "eCheck" ? "active" : "")}
                                                        role="presentation"
                                                        onClick={() => setPaymentType("eCheck")}
                                                    >
                                                        <a
                                                            className="nav-link text-center"
                                                            id="pills-home-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-home"
                                                            role="tab"
                                                            aria-controls="pills-home"
                                                            aria-selected="true"
                                                        >
                                                            <CustomRadio
                                                                checked={paymentType === "eCheck"}
                                                                onChange={() => {}}
                                                            />
                                                            <div className="check-btn">
                                                                <ECheckIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                eCheck
                                                            </div>
                                                        </a>
                                                    </li>)}
                                                    <li
                                                        className={classNames("nav-item chekbox-custom mr-2 me-2 rectangle", paymentType === "creditCard" ? "active" : "")}
                                                        role="presentation"
                                                        onClick={() => setPaymentType("creditCard")}
                                                    >
                                                        <a
                                                            className="nav-link text-center"
                                                            id="pills-profile-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-profile"
                                                            role="tab"
                                                            aria-controls="pills-profile"
                                                            aria-selected="false"
                                                        >
                                                            <CustomRadio
                                                                checked={paymentType === "creditCard"}
                                                                onChange={() => {}}
                                                            />
                                                            <div className="check-btn">
                                                                <CreditCardIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                Credit/Debit
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li
                                                        className={classNames("nav-item chekbox-custom me-2 rectangle", paymentType === "hhaCard" ? "active" : "")}
                                                        role="presentation"
                                                        onClick={() => setPaymentType("hhaCard")}
                                                    >
                                                        <a
                                                            className="nav-link text-center"
                                                            id="pills-contact-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-contact"
                                                            role="tab"
                                                            aria-controls="pills-contact"
                                                            aria-selected="false"
                                                        >
                                                            <CustomRadio
                                                                checked={paymentType === "hhaCard"}
                                                                onChange={() => {}}
                                                            />
                                                            <div className="check-btn">
                                                                <HhaCardIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                HHA/HHS card
                                                            </div>
                                                        </a>
                                                    </li>
                                                    {paymentGatewayType === 'NMI' && (
                                                        <li
                                                            style={{display: 'none'}}
                                                            className={classNames("nav-item chekbox-custom me-2 rectangle", paymentType === "applePay" ? "active" : "")}
                                                            role="presentation"
                                                            onClick={() => setPaymentType("applePay")}
                                                        >
                                                            <a
                                                                className="nav-link text-center"
                                                                id="pills-applepay-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-applepay"
                                                                role="tab"
                                                                aria-controls="pills-applepay"
                                                                aria-selected="false"
                                                            >
                                                                <CustomRadio
                                                                    checked={paymentType === "applePay"}
                                                                    onChange={() => {}}
                                                                />
                                                                <div className="check-btn">
                                                                    <ApplePayIcon/>
                                                                </div>
                                                                <div className="payment-checkbox-inner">
                                                                    Apple Pay
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )}
                                                    {paymentGatewayType === 'NMI' && (
                                                        <li
                                                            style={{display: 'none'}}
                                                            className={classNames("nav-item chekbox-custom me-2 rectangle", paymentType === "googlePay" ? "active" : "")}
                                                            role="presentation"
                                                            onClick={() => setPaymentType("googlePay")}
                                                        >
                                                            <a
                                                                className="nav-link text-center"
                                                                id="pills-googlepay-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-googlepay"
                                                                role="tab"
                                                                aria-controls="pills-googlepay"
                                                                aria-selected="false"
                                                            >
                                                                <CustomRadio
                                                                    checked={paymentType === "googlePay"}
                                                                    onChange={() => {}}
                                                                />
                                                                <div className="check-btn">
                                                                    <GooglePayIcon/>
                                                                </div>
                                                                <div className="payment-checkbox-inner">
                                                                    Google Pay
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )}
                                                </ul>
                                                <div className="tab-content" id="pills-tabContent">
                                                    <div
                                                        className={classNames("tab-pane", paymentType === "eCheck" ? "fade show active" : "")}
                                                        id="pills-home"
                                                        role="tabpanel"
                                                        aria-labelledby="pills-home-tab"
                                                    >
                                                        <div className="sos-content payment-inner-toggleable">
                                                            <form onSubmit={(e) => handleSubmit(e)}>
                                                                <div className="dropdown custom-dropdown mb-3">
                                                                    <select
                                                                        name="accountType"
                                                                        className="form-control custom-input-border-css"
                                                                        required
                                                                        onChange={(e) => handleInputChange(e)}
                                                                    >
                                                                        <option value="">Account Type</option>
                                                                        <option value="0">Personal</option>
                                                                        <option value="1">Business</option>
                                                                    </select>
                                                                    <div className="down-arrow">
                                                                        <DownArrowIcon/>
                                                                    </div>
                                                                </div>

                                                                {accountType === "0" ? (
                                                                    <div className="form-group mb-3">
                                                                        <label
                                                                            htmlFor="exampleInputBankName1"
                                                                            className="form-label payment-form-label"
                                                                        >
                                                                            Name On Account
                                                                        </label>
                                                                        <div className="row g-2">
                                                                            <div className="col-md">
                                                                                <div
                                                                                    className="payment-controlpanl-style">
                                                                                    <input
                                                                                        type="text"
                                                                                        name="accountFirstName"
                                                                                        className="form-control custom-input-border-css"
                                                                                        id="exampleInputName3"
                                                                                        aria-describedby="nameHelp"
                                                                                        placeholder="First Name"
                                                                                        onChange={(e) => handleInputChange(e)}
                                                                                        required
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md">
                                                                                <div>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="accountLastName"
                                                                                        className="form-control custom-input-border-css"
                                                                                        id="exampleInputName3"
                                                                                        aria-describedby="nameHelp"
                                                                                        placeholder="Last Name"
                                                                                        onChange={(e) => handleInputChange(e)}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>) : (<div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputBankName1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Name On Account
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="companyName"
                                                                        required
                                                                        className="form-control custom-input-border-css"
                                                                        id="exampleInputName1"
                                                                        aria-describedby="nameHelp"
                                                                        placeholder="Enter Name on the Account"
                                                                    />

                                                                </div>)}
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputBankName1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Bank Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="bankName"
                                                                        required
                                                                        className="form-control custom-input-border-css"
                                                                        id="exampleInputBankName"
                                                                        aria-describedby="bankNameHelp"
                                                                        placeholder="Enter Bank Name"
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputBankNumber1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Bank Routing Number
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        required
                                                                        className="form-control custom-input-border-css"
                                                                        name="bankRoutingNumber"
                                                                        id="exampleInputBankNumber1"
                                                                        placeholder="Enter Bank Routing Number"
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputAccountNumber1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Bank Account Number
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        className="form-control custom-input-border-css"
                                                                        id="exampleInputAccountNumber1"
                                                                        required
                                                                        name="bankAccountNumber"
                                                                        placeholder="Enter Bank Account Number"
                                                                    />
                                                                </div>

                                                                <div className="checkbox-list mt-3">
                                                                    <label
                                                                        className={`label-check font-weight-light float-end ${
                                                                            selectedAmount === "" ? "disabled-label" : ""
                                                                        }`}>
                                                                        <CustomCheckbox
                                                                            name="isPaymentSaveDetails"
                                                                            disabled={selectedAmount === ""}
                                                                            checked={selectedAmount === "" ? true : isPaymentSaveDetails}
                                                                            onChange={(e) => setIsPaymentSaveDetails(e.target.checked)}
                                                                        />
                                                                        Save these payment details for future
                                                                        payments
                                                                    </label>
                                                                    <div className="payment-checbox">
                                                                        <label
                                                                            className="font-weight-light label-check ml-xl-5">
                                                                            <CustomCheckbox
                                                                                name="isDefault"
                                                                                onChange={(e) => setIsDefault(e.target.checked)}
                                                                            />
                                                                            Set as default payment method
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex justify-content-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="sos-mack-btn sos-custom-btn-css"
                                                                        disabled={transactionLoading}
                                                                    >

                                                                        {withButtonLoader(`${
                                                                            selectedAmount === ""
                                                                                ? "Add Payment Method"
                                                                                : "Make a Payment"
                                                                        }`, transactionLoading)}
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    {inAppBrowserWarning && (
                                                        <div className={`in-app-browser-banner${inAppBlocked ? ' in-app-browser-banner--blocked' : ''}`}>
                                                            <div className="in-app-browser-banner-content">
                                                                <span className="in-app-browser-banner-icon">⚠</span>
                                                                <div className="in-app-browser-banner-text">
                                                                    <strong>In-App Browser Detected</strong>
                                                                    <span>{inAppBlocked
                                                                        ? `You're viewing this page inside ${inAppBrowserWarning.app}. In-app browsers block payment processing.`
                                                                        : `You're viewing this page inside ${inAppBrowserWarning.app}. Payments may not work correctly. For the best experience, open this page in your default browser.`
                                                                    }</span>
                                                                    <span className="in-app-browser-instructions">{getInAppBrowserInstructions(inAppBrowserWarning.app)}</span>
                                                                </div>
                                                            </div>
                                                            <div className="in-app-browser-banner-actions">
                                                                {/Android/i.test(navigator.userAgent) ? (
                                                                    <button className="in-app-browser-open-btn" onClick={() => {
                                                                        const url = window.location.href;
                                                                        window.location.href = 'intent://' + url.replace(/^https?:\/\//, '') + '#Intent;scheme=https;end';
                                                                    }}>Open in Browser</button>
                                                                ) : (
                                                                    <button className={`in-app-browser-open-btn${linkCopied ? ' in-app-browser-open-btn--copied' : ''}`} onClick={async () => {
                                                                        const ok = await copyCurrentUrl();
                                                                        if (ok) {
                                                                            setLinkCopied(true);
                                                                            setTimeout(() => setLinkCopied(false), 3000);
                                                                        }
                                                                    }}>{linkCopied ? 'Link Copied! Paste in Safari' : 'Copy Link'}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {paymentGatewayType === 'NMI' ? (
                                                        paymentLoadError ? (
                                                            <div style={{padding: '12px', color: '#c0392b', fontSize: '14px', textAlign: 'center'}}>
                                                                {paymentLoadError}
                                                            </div>
                                                        ) : (
                                                        <CreditCardManualNmiFields
                                                            paymentType={paymentType}
                                                            handleInputChange={handleInputChange}
                                                            handleSubmit={handleSubmit}
                                                            isPaymentSaveDetails={isPaymentSaveDetails}
                                                            setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                            isDefault={isDefault}
                                                            setIsDefault={setIsDefault}
                                                            transactionLoading={transactionLoading}
                                                            buttonText={selectedAmount === "" ? "Add Payment Method" : "Make a Payment"}
                                                            selectedAmount={selectedAmount}
                                                        />
                                                        )
                                                    ) : (
                                                        <div
                                                            className={classNames("tab-pane", paymentType === "creditCard" ? "fade show active" : "")}
                                                            id="pills-profile"
                                                            role="tabpanel"
                                                            aria-labelledby="pills-profile-tab"
                                                        >
                                                            <div className="sos-content payment-inner-toggleable">
                                                                <form onSubmit={(e) => handleSubmit(e)}>
                                                                    <div className="form-group mb-3">
                                                                        <label
                                                                            htmlFor="exampleInputEmail1"
                                                                            className="form-label payment-form-label"
                                                                        >
                                                                            Cardholder Name
                                                                        </label>
                                                                        <div className="row g-2">
                                                                            <div className="col-md">
                                                                                <div
                                                                                    className="payment-controlpanl-style">
                                                                                    <input
                                                                                        type="text"
                                                                                        name="cardFirstName"
                                                                                        className="form-control custom-input-border-css"
                                                                                        id="exampleInputName3"
                                                                                        aria-describedby="nameHelp"
                                                                                        placeholder="First Name"
                                                                                        onChange={(e) => handleInputChange(e)}
                                                                                        required
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md">
                                                                                <div>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="cardLastName"
                                                                                        className="form-control custom-input-border-css"
                                                                                        id="exampleInputName3"
                                                                                        aria-describedby="nameHelp"
                                                                                        placeholder="Last Name"
                                                                                        onChange={(e) => handleInputChange(e)}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group mb-3">
                                                                        <label
                                                                            htmlFor="exampleInputPassword1"
                                                                            className="form-label payment-form-label"
                                                                        >
                                                                            Credit Card Number
                                                                        </label>
                                                                        <input
                                                                            type="tel"
                                                                            name="cardnumber"
                                                                            className="form-control custom-input-border-css"
                                                                            id="cardnumber"
                                                                            placeholder="Enter Credit Card Number"
                                                                            pattern="[\d ]{15,22}"
                                                                            required
                                                                            onChange={(e) => handleInputChange(e)}
                                                                        />
                                                                    </div>
                                                                    <div className="row g-2">
                                                                        <div className="col-md">
                                                                            <div
                                                                                className="payment-controlpanl-style">
                                                                                <div>
                                                                                    <label
                                                                                        className="payment-form-label">
                                                                                        Expiry Date
                                                                                    </label>
                                                                                </div>
                                                                                <CardExpiration
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                ></CardExpiration>
                                                                                {/*<input*/}
                                                                                {/*    type="tel"*/}
                                                                                {/*    className="form-control custom-input-border-css"*/}
                                                                                {/*    id="creidtExpiryDate"*/}
                                                                                {/*    placeholder="mm/yy"*/}
                                                                                {/*    name="expiry"*/}
                                                                                {/*    pattern="\d\d/\d\d"*/}
                                                                                {/*    required*/}
                                                                                {/*    onChange={(e) => handleInputChange(e)}*/}
                                                                                {/*/>*/}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md">
                                                                            <div>
                                                                                <div>
                                                                                    <label
                                                                                        className="payment-form-label">
                                                                                        Security Code
                                                                                    </label>
                                                                                </div>
                                                                                <input
                                                                                    type="tel"
                                                                                    className="form-control custom-input-border-css"
                                                                                    placeholder="Enter CVC"
                                                                                    name="cvc"
                                                                                    pattern="\d{3,4}"
                                                                                    required
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="checkbox-list mt-3">
                                                                        <label
                                                                            className={`label-check font-weight-light ${
                                                                                selectedAmount === "" ? "disabled-label" : ""
                                                                            }`}>
                                                                            <CustomCheckbox
                                                                                name="isPaymentSaveDetails"
                                                                                disabled={selectedAmount === ""}
                                                                                checked={selectedAmount === "" ? true : isPaymentSaveDetails}
                                                                                onChange={(e) => setIsPaymentSaveDetails(e.target.checked)}
                                                                            />
                                                                            <span>
                                              Save these payment details for future
                                              payments
                                            </span>
                                                                        </label>
                                                                        <div className="payment-checbox">
                                                                            <label
                                                                                className="font-weight-light label-check ml-xl-5">
                                                                                <CustomCheckbox
                                                                                    name="isDefault"
                                                                                    onChange={(e) => setIsDefault(e.target.checked)}
                                                                                />
                                                                                <span
                                                                                    className="word-break: break-word">
                                                Set as default payment method
                                              </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-center">
                                                                        <button
                                                                            type="submit"
                                                                            className="sos-mack-btn sos-custom-btn-css"
                                                                            disabled={transactionLoading}
                                                                        >
                                                                            {withButtonLoader(`${
                                                                                selectedAmount === ""
                                                                                    ? "Add Payment Method"
                                                                                    : "Make a Payment"
                                                                            }`, transactionLoading)}
                                                                        </button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div
                                                        className={classNames("tab-pane fade", paymentType === "debitCard" ? "show active" : "")}
                                                        id="pills-contact"
                                                        role="tabpanel"
                                                        aria-labelledby="pills-contact-tab"
                                                    >
                                                        <div className="sos-content payment-inner-toggleable">
                                                            <form>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputEmail1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Cardholder Name
                                                                    </label>
                                                                    <div className="row g-2">
                                                                        <div className="col-md">
                                                                            <div
                                                                                className="payment-controlpanl-style">
                                                                                <input
                                                                                    type="text"
                                                                                    name="cardFirstName"
                                                                                    className="form-control custom-input-border-css"
                                                                                    id="exampleInputName3"
                                                                                    aria-describedby="nameHelp"
                                                                                    placeholder="First Name"
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                    required
                                                                                />

                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md">
                                                                            <div>
                                                                                <input
                                                                                    type="text"
                                                                                    name="cardLastName"
                                                                                    className="form-control custom-input-border-css"
                                                                                    id="exampleInputName3"
                                                                                    aria-describedby="nameHelp"
                                                                                    placeholder="Last Name"
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputPassword1"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Debit Card Number
                                                                    </label>
                                                                    <input
                                                                        type="tel"
                                                                        className="form-control custom-input-border-css"
                                                                        id="debitcardNumber"
                                                                        placeholder="Enter Debit Card Number"
                                                                    />
                                                                </div>
                                                                <div className="row g-2">
                                                                    <div className="col-md">
                                                                        <div
                                                                            className="payment-controlpanl-style">
                                                                            <div>
                                                                                <label
                                                                                    className="payment-form-label">
                                                                                    Expiry Date
                                                                                </label>
                                                                            </div>
                                                                            <CardExpiration
                                                                                onChange={(e) => handleInputChange(e)}
                                                                            ></CardExpiration>
                                                                            {/*<input*/}
                                                                            {/*    type="date"*/}
                                                                            {/*    className="form-control custom-input-border-css"*/}
                                                                            {/*    id="debitExpiryDate"*/}
                                                                            {/*    placeholder="mm/yy"*/}
                                                                            {/*/>*/}

                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md">
                                                                        <div>
                                                                            <div>
                                                                                <label
                                                                                    className="payment-form-label">
                                                                                    Security Code
                                                                                </label>
                                                                            </div>
                                                                            <input
                                                                                type="tel"
                                                                                className="form-control custom-input-border-css"
                                                                                id="floatingInputGrid"
                                                                                placeholder="Enter CVC"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="checkbox-list mt-3">
                                                                    <label
                                                                        className={`label-check font-weight-light float-end ${
                                                                            selectedAmount === "" ? "disabled-label" : ""
                                                                        }`}>
                                                                        <CustomCheckbox
                                                                            name="isPaymentSaveDetails"
                                                                            disabled={selectedAmount === ""}
                                                                            checked={selectedAmount === "" ? true : isPaymentSaveDetails}
                                                                            onChange={(e) => setIsPaymentSaveDetails(e.target.checked)}
                                                                        />
                                                                        Save these payment details for future
                                                                        payments
                                                                    </label>
                                                                    <div className="payment-checbox">
                                                                        <label
                                                                            className="font-weight-light label-check ml-xl-5">
                                                                            <CustomCheckbox
                                                                                name="isDefault"
                                                                                checked={isDefault}
                                                                                onChange={(e) => setIsDefault(e.target.checked)}
                                                                            />
                                                                            Set as default payment method
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="sos-mack-btn sos-custom-btn-css"
                                                                        disabled={transactionLoading}
                                                                    >
                                                                        {withButtonLoader(`${
                                                                            selectedAmount === ""
                                                                                ? "Add Payment Method"
                                                                                : "Make a Payment"
                                                                        }`, transactionLoading)}
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`tab-pane fade ${paymentType === "hhaCard" ? "show active" : ""}`}
                                                        id="pills-contact"
                                                        role="tabpanel"
                                                        aria-labelledby="pills-contact-tab"
                                                    >
                                                        {paymentGatewayType === 'NMI' ? (
                                                            paymentLoadError ? (
                                                                <div style={{padding: '12px', color: '#c0392b', fontSize: '14px', textAlign: 'center'}}>
                                                                    {paymentLoadError}
                                                                </div>
                                                            ) : (
                                                            <CreditCardManualNmiFields
                                                                paymentType={paymentType}
                                                                handleInputChange={handleInputChange}
                                                                handleSubmit={handleSubmit}
                                                                isPaymentSaveDetails={isPaymentSaveDetails}
                                                                setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                                isDefault={isDefault}
                                                                setIsDefault={setIsDefault}
                                                                transactionLoading={transactionLoading}
                                                                buttonText={selectedAmount === "" ? "Add Payment Method" : "Make a Payment"}
                                                                selectedAmount={selectedAmount}
                                                            />
                                                            )
                                                        ) : (
                                                        <div className="sos-content payment-inner-toggleable">
                                                            <form onSubmit={(e) => handleSubmit(e)}>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputName4"
                                                                        className="form-label payment-form-label"
                                                                    >
                                                                        Cardholder Name
                                                                    </label>
                                                                    <div className="row g-2">
                                                                        <div className="col-md">
                                                                            <div
                                                                                className="payment-controlpanl-style">
                                                                                <input
                                                                                    type="text"
                                                                                    name="cardFirstName"
                                                                                    className="form-control custom-input-border-css"
                                                                                    id="exampleInputName3"
                                                                                    aria-describedby="nameHelp"
                                                                                    placeholder="First Name"
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                    required
                                                                                />

                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md">
                                                                            <div>
                                                                                <input
                                                                                    type="text"
                                                                                    name="cardLastName"
                                                                                    className="form-control custom-input-border-css"
                                                                                    id="exampleInputName3"
                                                                                    aria-describedby="nameHelp"
                                                                                    placeholder="Last Name"
                                                                                    onChange={(e) => handleInputChange(e)}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group mb-3">
                                                                    <label
                                                                        htmlFor="exampleInputPassword1"
                                                                        className="form-label payment-form-label "
                                                                    >
                                                                        HHA/HHS Card Number
                                                                    </label>
                                                                    <input
                                                                        type="tel"
                                                                        name="cardnumber"
                                                                        className="form-control custom-input-border-css"
                                                                        placeholder="Enter HHA/HHS Card Number"
                                                                        pattern="[\d ]{15,22}"
                                                                        required
                                                                        onChange={(e) => handleInputChange(e)}
                                                                    />
                                                                </div>
                                                                <div className="row g-2">
                                                                    <div className="col-md">
                                                                        <div
                                                                            className="payment-controlpanl-style">
                                                                            <div>
                                                                                <label
                                                                                    className="payment-form-label">
                                                                                    Expiry Date
                                                                                </label>
                                                                            </div>
                                                                            <CardExpiration
                                                                                onChange={(e) => handleInputChange(e)}
                                                                            ></CardExpiration>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md">
                                                                        <div>
                                                                            <div>
                                                                                <label
                                                                                    className="payment-form-label">
                                                                                    Security Code
                                                                                </label>
                                                                            </div>
                                                                            <input
                                                                                type="tel"
                                                                                className="form-control custom-input-border-css"
                                                                                placeholder="Enter CVC"
                                                                                name="cvc"
                                                                                pattern="\d{3,4}"
                                                                                required
                                                                                onChange={(e) => handleInputChange(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="checkbox-list mt-3">
                                                                    <label
                                                                        className={`label-check font-weight-light float-end ${
                                                                            selectedAmount === "" ? "disabled-label" : ""
                                                                        }`}>
                                                                        <CustomCheckbox
                                                                            name="isPaymentSaveDetails"
                                                                            disabled={selectedAmount === ""}
                                                                            checked={selectedAmount === "" ? true : isPaymentSaveDetails}
                                                                            onChange={(e) => setIsPaymentSaveDetails(e.target.checked)}
                                                                        />
                                                                        Save these payment details for future
                                                                        payments
                                                                    </label>
                                                                    <div className="payment-checbox">
                                                                        <label
                                                                            className="font-weight-light label-check ml-xl-5 ">
                                                                            <CustomCheckbox
                                                                                name="isDefault"
                                                                                checked={isDefault}
                                                                                onChange={(e) => setIsDefault(e.target.checked)}
                                                                            />
                                                                            Set as default payment method
                                                                        </label>

                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="sos-mack-btn sos-custom-btn-css"
                                                                        disabled={transactionLoading}
                                                                    >
                                                                        {withButtonLoader("Make a Payment", transactionLoading)}
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                </>)}
                                            </div>
                                        </div>) : (<>

                                        {user?.paymentMethods?.length > 0 ? (<React.Fragment>
                                            <div className="pay-saved-method">
                                                <div className="pay-patient-style">
                                                    {user?.paymentMethods?.length > 0 ? "Saved Payment Methods" : ""}
                                                </div>

                                                <div className="pay-toggleable d-flex row ">

                                                    {map(user.paymentMethods, (c, i) => {
                                                        let paymentMethodDisplay;
                                                        if (paymentGatewayType === 'NMI') {
                                                            if (c.cardType && c.cardNumber) {
                                                                let cardTypeDisplay = c.cardType?.toUpperCase();
                                                                if (cardTypeDisplay === 'MASTERCARD') {
                                                                    cardTypeDisplay = 'MC';
                                                                }
                                                                paymentMethodDisplay = `${cardTypeDisplay} ${c.cardNumber}`;
                                                            } else if (c.paymentType === 'eCheck') {
                                                                paymentMethodDisplay = `eCheck`;
                                                            }
                                                        } else if (paymentGatewayType === 'converge') {
                                                            if (c.ssl_card_short_description) {
                                                                paymentMethodDisplay = `${c.ssl_card_short_description} **** ${c.ssl_card_number.slice(-4)}`;
                                                            } else {
                                                                paymentMethodDisplay = `eCheck ** ${c.ssl_bank_account_number.slice(-4)}`;
                                                            }
                                                        }

                                                        return (<ul
                                                            key={i}
                                                            className="mb-3 nav nav-pills col-lg-4 col-xl-4 col-md-6 justify-content-center  cursor-pointer"
                                                            onClick={() => {
                                                                setSelectedCardId(c._id);
                                                                setSelectedPayment(c);
                                                            }}
                                                        >
                                                            <li
                                                                className={("nav-item custom-tab border-1 ml-8", selectedCardId === c._id ? " nav-item active select-card" : " nav-item custom-tab")}
                                                                role="presentation"
                                                            >
                                                                <a
                                                                    className="nav-link text-center "
                                                                    id="pills-home-tab"
                                                                    data-bs-toggle="pill"
                                                                    data-bs-target="#pills-home"
                                                                    role="tab"
                                                                    aria-controls="pills-home"
                                                                    aria-selected="true"
                                                                >
                                                                    <div
                                                                        className="check-btn d-flex mb-0">
                                                                        {c.ssl_card_short_description === "eCheck" ? (
                                                                            <ECheckIcon/>) : (
                                                                            <CreditCardIcon/>)}
                                                                        <span
                                                                            className="text-dark payment-card-text">{paymentMethodDisplay}
                                              </span>
                                                                    </div>
                                                                    <div
                                                                        className="mb-0 ml-8 text-start text-dark mt-1">
                                                                        <label
                                                                            className="font-weight-light label-check sos-checkbox">
                                                                            <CustomCheckbox
                                                                                checked={c.isDefault}
                                                                                onChange={(e) => onDefaultChecked(e, c, i)}
                                                                            />
                                                                            <span
                                                                                className="payment-style payment-method-text">
                                                  Default Method
                                                </span>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="check-btn d-flex auto-payment text-dark">

                                                                    </div>
                                                                    <div className="divider"/>
                                                                    <div className="d-flex">
                                              {/*<span*/}
                                              {/*    className="text-cerulean text-decoration-underline ml-8"*/}
                                              {/*    onClick={() => handleEditInfo()}*/}
                                              {/*>*/}
                                              {/*  Edit*/}
                                              {/*</span>*/}
                                                                        <span
                                                                            className="text-cerulean text-decoration-underline"
                                                                            onClick={(e) => handlePopUp(e, c)}
                                                                        >
                                                Remove
                                              </span>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        </ul>);
                                                    })}
                                                </div>
                                                {selectedAmount > "" && <div className="d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        onClick={(e) => payWithSelected(e)}
                                                        className="sos-mack-btn sos-custom-btn-css"
                                                        disabled={transactionLoading}
                                                    >
                                                        {withButtonLoader("Process Payment", transactionLoading)}
                                                    </button>
                                                </div>}
                                            </div>
                                            <div className="pay-saved-inner-block">
                                                <div className="or-line"/>
                                                {selectedAmount > "" ?
                                                    (<div className="payment-raound">
                                                        <span>OR</span>
                                                    </div>) : (<div className="payment-raound-secondary">
                                                        <span></span>
                                                    </div>)
                                                }
                                            </div>
                                        </React.Fragment>) : ("")}

                                        {(selectedAmount > "" || adminUser.displayAddPaymentMethod) && (<>
                                            <div className="pay-patient-style select-payment">
                                                {selectedAmount > '' ? `Pay With a New Payment Method` : 'Add Payment Method'}
                                            </div>
                                            <div className="container pay-toggleable">
                                                <ul
                                                    className=" justify-content-around mb-3 nav nav-pills"
                                                    id="pills-tab"
                                                    role="tablist"
                                                >
                                                    {adminUser.displayECheck && (<li
                                                        // me-5
                                                        className="nav-item chekbox-custom mr-2 rectangle"
                                                        role="presentation"
                                                        onClick={() => setPaymentType("eCheck")}
                                                    >
                                                        <a
                                                            className={classNames("nav-link text-center", paymentType === "eCheck" ? "active" : "")}
                                                            id="pills-home-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-home"
                                                            role="tab"
                                                            aria-controls="pills-home"
                                                            aria-selected="true"
                                                        >
                                                            <div className="check-btn">
                                                                <ECheckIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                eCheck
                                                            </div>
                                                        </a>
                                                    </li>)}
                                                    <li
                                                        className="nav-item chekbox-custom mr-2 rectangle"
                                                        role="presentation"
                                                        onClick={() => setPaymentType("creditCard")}
                                                    >
                                                        <a
                                                            className={classNames("nav-link text-center", paymentType === "creditCard" ? "active" : "")}
                                                            id="pills-profile-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-profile"
                                                            role="tab"
                                                            aria-controls="pills-profile"
                                                            aria-selected="false"
                                                        >
                                                            <div className="check-btn">
                                                                <CreditCardIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                Credit/Debit Card
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li
                                                        className="nav-item chekbox-custom rectangle"
                                                        role="presentation"
                                                        onClick={() => setPaymentType("hhaCard")}
                                                    >
                                                        <a
                                                            className={classNames("nav-link text-center", paymentType === "hhaCard" ? "active" : "")}
                                                            id="pills-contact-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-contact"
                                                            role="tab"
                                                            aria-controls="pills-contact"
                                                            aria-selected="false"
                                                        >
                                                            <div className="check-btn">
                                                                <HhaCardIcon/>
                                                            </div>
                                                            <div className="payment-checkbox-inner">
                                                                HHA/HHS card
                                                            </div>
                                                        </a>
                                                    </li>
                                                    {paymentGatewayType === 'NMI' && (
                                                        <li
                                                            style={{display: 'none'}}
                                                            className="nav-item chekbox-custom rectangle"
                                                            role="presentation"
                                                            onClick={() => setPaymentType("applePay")}
                                                        >
                                                            <a
                                                                className={classNames("nav-link text-center", paymentType === "applePay" ? "active" : "")}
                                                                id="pills-applepay-tab2"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-applepay"
                                                                role="tab"
                                                                aria-controls="pills-applepay"
                                                                aria-selected="false"
                                                            >
                                                                <div className="check-btn">
                                                                    <ApplePayIcon/>
                                                                </div>
                                                                <div className="payment-checkbox-inner">
                                                                    Apple Pay
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )}
                                                    {paymentGatewayType === 'NMI' && (
                                                        <li
                                                            style={{display: 'none'}}
                                                            className="nav-item chekbox-custom rectangle"
                                                            role="presentation"
                                                            onClick={() => setPaymentType("googlePay")}
                                                        >
                                                            <a
                                                                className={classNames("nav-link text-center", paymentType === "googlePay" ? "active" : "")}
                                                                id="pills-googlepay-tab2"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-googlepay"
                                                                role="tab"
                                                                aria-controls="pills-googlepay"
                                                                aria-selected="false"
                                                            >
                                                                <div className="check-btn">
                                                                    <GooglePayIcon/>
                                                                </div>
                                                                <div className="payment-checkbox-inner">
                                                                    Google Pay
                                                                </div>
                                                            </a>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </>)}
                                        {paymentType === "applePay" && paymentGatewayType === 'NMI' && (
                                            <div className="sos-content payment-inner-toggleable">
                                                <ApplePayNmi
                                                    subdomain={subdomain}
                                                    adminUser={adminUser}
                                                    user={user}
                                                    totalAmount={totalAmountsPaid()}
                                                    patientPayerInfo={patientPayerInfo}
                                                    showResult={showResult}
                                                    setPaymentInfo={setPaymentInfo}
                                                />
                                            </div>
                                        )}
                                        {paymentType === "googlePay" && paymentGatewayType === 'NMI' && (
                                            <div className="sos-content payment-inner-toggleable">
                                                <GooglePayNmi
                                                    subdomain={subdomain}
                                                    adminUser={adminUser}
                                                    user={user}
                                                    totalAmount={totalAmountsPaid()}
                                                    patientPayerInfo={patientPayerInfo}
                                                    showResult={showResult}
                                                    setPaymentInfo={setPaymentInfo}
                                                />
                                            </div>
                                        )}
                                    </>)}
                                </div>
                            </div>) : (<EditCardInfo
                                patientPayerInfo={patientPayerInfo}
                                paymentType={paymentType}
                                subdomain={subdomain}
                                paymentMethodData={selectedPayment}
                                setEditCardInfo={setEditCardInfo}
                            />)}
                            {editCardInfo ? (<></>) : (<div></div>
                                // <div className="hommeexisting-img">
                                //   <img src="../images/payment-icon.png" />
                                // </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <CustomPopover
                title={"Are you sure you want to remove this payment method?"}
                show={showPopUp}
                target={target}
                onRemove={onRemoveDoc}
                close={handleClosePopUp}
                setShowPopUp={setShowPopUp}
            />
            <PaymentSuccessPopup
                openModal={openModal}
                paymentMsg={paymentMsg}
                errorType={errorType}
                errorKey={errorKey}
                originalTransaction={originalTransaction}
                onCloseModal={onCloseModal}
                officeName={adminUser.officeName}
            />
        </div>
    </>);
};
const mapDispatchToProps = {
    savePaymentsData, deleteCard,
};
export default connect(null, mapDispatchToProps)(Payments);
